import { createSlice } from "@reduxjs/toolkit"

const { reducer, actions } = createSlice({
  name: "stopped",
  initialState: {
    byDeviceId: {}, // { [deviceId]: timestampISO | null }
  },
  reducers: {
    setStoppedSince(state, action) {
      const { deviceId, timestamp } = action.payload
      state.byDeviceId[deviceId] = timestamp
    },
    clearStoppedSince(state, action) {
      const { deviceId } = action.payload
      state.byDeviceId[deviceId] = null
    },
  },
})

export { actions as stoppedActions }
export { reducer as stoppedReducer }